import AccountAPI from '@/app/api/AccountAPI/AccountAPI';
import { useAnalytics } from '@/app/context/AnalyticsContext/useAnalytics';
import React from 'react';

export default function DeleteAccount() {
  const { trackEvent, analyticsInstance } = useAnalytics();

  const onDelete = async () => {
    trackEvent(analyticsInstance, 'account_click_delete');

    const confirm = window.confirm(
      'Are you sure you want to delete your account? All subscriptions will be canceled and data deleted.  You will be immediately redirected to the home page.'
    );

    if (confirm) {
      trackEvent(analyticsInstance, 'account_delete_confirm');
      await AccountAPI.deleteAccount();
      trackEvent(analyticsInstance, 'account_delete_success');
      window.alert('Account deleted successfully.');
      window.location.href = '/';
    }
  };

  return (
    <div className="flex flex-col gap-4 pr-8">
      <button
        onClick={onDelete}
        className="btn btn-sm bg-neutral text-neutral-content"
      >
        Delete Account
      </button>
      <div className="italic" style={{ maxWidth: 300 }}>
        Deleting your Limbiks account will delete all of your upload data, user
        data and automatically cancel all subscriptions.
      </div>
    </div>
  );
}
